import { render, staticRenderFns } from "./main-expand-button.vue?vue&type=template&id=df70f630&scoped=true"
import script from "./main-expand-button.vue?vue&type=script&lang=js"
export * from "./main-expand-button.vue?vue&type=script&lang=js"
import style0 from "./main-expand-button.vue?vue&type=style&index=0&id=df70f630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df70f630",
  null
  
)

export default component.exports